import { styled } from '@mui/material/styles';
import { Button } from 'components/buttons';

export const AccountImage = styled('div')(() => ({
  display: 'flex',
  marginRight: '25px',
  '& svg': {
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    margin: '16px 16px 16px 0'
  },
  '& label': {
    marginTop: '30px'
  },
  '& img': {
    width: '109px',
    height: '109px',
    objectFit: 'cover'
  }
}));

export const AddButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`
}));
